import { render } from "./DosisMed.vue?vue&type=template&id=d2d39fe2&scoped=true"
import script from "./DosisMed.vue?vue&type=script&lang=js"
export * from "./DosisMed.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=d2d39fe2&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2d39fe2"]])

export default __exports__